import { render } from "./ImprestApproval.vue?vue&type=template&id=dda031e0&scoped=true"
import script from "./ImprestApproval.vue?vue&type=script&lang=js"
export * from "./ImprestApproval.vue?vue&type=script&lang=js"

import "./ImprestApproval.vue?vue&type=style&index=0&id=dda031e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dda031e0"]])

export default __exports__